module.exports = __webpack_public_path__ + "static/image3-bb24906b6ca43695bb5dcfc02180dfb4.png";